import React, { useState } from "react";
import ReactPlayer from "react-player";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import { Button, Card } from "semantic-ui-react";
import "./CsaMedia.css";
import DeleteMedia from "./DeleteMedia";
import EditMedia from "./EditMedia";
import MoreModal from "./MoreModal";

const MediaCard = (props) => {
  const [more, setMore] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [edit, setEdit] = useState(null);
  return (
    <>
      <Card className="schools-cards">
        <div className="ifame-data">
          <div className="ui active embed schools">
            {props.data?.fileType.startsWith("video") ? (
              <div className="embed">
                <ReactPlayer
                  controls={true}
                  muted
                  url={
                    props.data?.fileURL
                      ? props.data?.fileURL
                      : props.data?.videoURL
                  }
                />
              </div>
            ) : (
              <div
                className="image-preview-data full"
                style={{
                  background: `url(${
                    props.data?.fileURL
                      ? props.data?.fileURL
                      : props.data?.videoURL
                  })`,
                }}
              />
            )}
          </div>
        </div>
        <Card.Content>
          <Card.Header>
            <a
              href=""
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#191919" }}
            >
              {props.data.title}
            </a>
          </Card.Header>
        </Card.Content>
        <Card.Content extra>
          <p class="line-break-4">{props.data.content}</p>
          <a onClick={() => setMore(props.data)} href="javascript:void(0)">
            Read More
          </a>
        </Card.Content>
        {props.superAdmin && (
          <Card.Content extra>
            <Button
              circular
              icon="edit"
              color="blue"
              onClick={() => setEdit(props.data)}
            />
            <Button
              circular
              loading={props.deleting}
              icon="trash"
              color="red"
              onClick={() => setDeleteId(props.data.id)}
            />
          </Card.Content>
        )}
      </Card>
      {deleteId && (
        <DeleteMedia
          deleteId={deleteId}
          close={() => {
            setDeleteId(null);
          }}
        />
      )}

      {edit && (
        <EditMedia
          open={edit}
          close={() => {
            setEdit(null);
          }}
        />
      )}
      {more && <MoreModal open={more} close={() => setMore(null)} />}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    superAdmin: state.auth.superAdmin,
    deleted: state.media.deleted,
    deleteERROR: state.media.deleteERROR,
    deleting: state.media.deleting,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect((props) => {
    const firestoreArray = [
      {
        collection: "partnersOrder",
      },
    ];
    return firestoreArray;
  })
)(MediaCard);
